import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import * as CMP from '@edreamsodigeo/frontend-cmp-client';
import { getGeoLocations } from '../../redux/geoLocations/actions';
import { initPreviousSearches } from '../../redux/previousSearch/actions';
import { getFilteredPreviousSearches } from '../../redux/previousSearch/selectors';
import { ABUtils, Config, URLUtils } from '../../utils';
import { CurrentAccommodationSearchService } from '../../services';
import { EntryPoint } from '../../models';

function shouldHideChildren({
    isHotelsVisibility,
    isHome,
    isEdit,
    isPreviousSearchesInitialized,
    filteredPreviousSearches,
}) {
    return (
        isHotelsVisibility &&
        isHome &&
        !isEdit &&
        (!isPreviousSearchesInitialized ||
            (filteredPreviousSearches && filteredPreviousSearches.length === 0))
    );
}

function activateFlightsMenu({ isHotelsVisibility, isHome, filteredPreviousSearches }) {
    if (isHotelsVisibility && isHome && filteredPreviousSearches && filteredPreviousSearches.length > 0) {
        window.hotelVisibilityTestConfig();
    }
}

export const SearchManager = ({ children }) => {
    const { isHotelsVisibility } = ABUtils.getABs();
    const entryPoint = Config.get('entryPoint');
    const isHome = entryPoint === EntryPoint.HOME;
    const isEdit = -1 < window.location.hash.indexOf('flights/edit');
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const isPreviousSearchesInitialized = useSelector(
        (state) => state.previousSearches?.isInitialized
    );

    useEffect(() => {
        const urlParams = URLUtils.getHomeHashParams();
        if (!isEmpty(urlParams)) {
            dispatch(getGeoLocations(urlParams));
        }

        if (CMP.isAllowed('localStorage', 'previous-search-data')) {
            dispatch(initPreviousSearches());
        } else {
            CMP.onChangeUserCMP(() => {
                dispatch(initPreviousSearches());
            });
        }
    }, [dispatch]);

    useEffect(() => {
        if (state.currentSearch) {
            CurrentAccommodationSearchService.updateReduxStoreOrInitializeSessionStorage(state, dispatch);
        }
    }, []);

    const filteredPreviousSearches = useSelector(getFilteredPreviousSearches, shallowEqual);

    const hideChildren = shouldHideChildren({
        isHotelsVisibility,
        isHome,
        isEdit,
        isPreviousSearchesInitialized,
        filteredPreviousSearches
    });

    useEffect(() => {
        if (!hideChildren) {
            activateFlightsMenu({ isHotelsVisibility, isHome, filteredPreviousSearches });
        }
    }, [
        isHotelsVisibility,
        isHome,
        isEdit,
        isPreviousSearchesInitialized,
        filteredPreviousSearches,
        hideChildren
    ]);

    if (hideChildren) {
        return null;
    }

    return children;
};

SearchManager.propTypes = {
    children: PropTypes.node.isRequired,
};
